import templateUrl from './unclaimed-work-orders.component.html'

export const DashboardUnclaimedWorkOrdersComponent = {
    bindings: {
        workOrders: "<",
        onAssign: "&"
    },
    controllerAs: "vm",
    controller: class UnclaimedWorkOrdersController {
        constructor() {
            this.pageNumber = 1
            this.pageSize = 10
        }
    },
    templateUrl
}
